// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import {
    chain,
    PopulateApiParameter,
    SetCreditCard,
} from "@insite/client-framework/Store/Pages/OnePageCheckout/Handlers/PlaceOrder";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";

export const XngPopulateApiParameter: typeof PopulateApiParameter = props => {
    if (!props.cartToUpdate) {
        return;
    }
    const state = props.getState();

    props.apiParameter = {
        cart: {
            ...props.cartToUpdate,
            notes: state.pages.checkoutShipping.editedCartNotes || "",
            poNumber: props.parameter.poNumber,
        },
    };
};

export const XngSetCreditCard: typeof SetCreditCard = props => {
    const { cartToUpdate } = props;

    if (
        cartToUpdate.paymentMethod?.isCreditCard &&
        !props.parameter.isAdyenDropIn &&
        !props.parameter.useBillingAddress
    ) {
        (cartToUpdate.paymentOptions!.creditCard as any).address2 = (props.parameter as any).address2;
    }
};

export const XngSendPriceSpiderTracking = (props: any) => {
    if (typeof window !== "undefined") {
        const pswtb = (window as any).pswtb;
        if (pswtb) {
            const order = pswtb.purchaseTracking.createOrder();
            order.details = props.apiParameter.cart.cartLines.map(
                ({ id, erpNumber, brand, shortDescription, pricing, qtyOrdered }: CartLineModel) => ({
                    id,
                    sku: erpNumber,
                    manufacturer: brand?.name,
                    productName: shortDescription,
                    unitPrice: pricing?.unitNetPrice,
                    quantity: qtyOrdered,
                }),
            );
            order.currencyCode = getSession(props.getState()).currency?.currencyCode;
            order.purchaseTotal = props.apiParameter.cart.orderGrandTotal;
            order.redirectToken = sessionStorage.getItem("psrid");
            order.submit();
        }
    }
};

addToChainAfter(chain, PopulateApiParameter, XngPopulateApiParameter);
addToChainAfter(chain, PopulateApiParameter, XngSendPriceSpiderTracking);
addToChainAfter(chain, SetCreditCard, XngSetCreditCard);
